let url = process.env.VUE_APP_API
let fileUrl = 'http://files.crm.139tm.com'

const tenantId = process.env.VUE_APP_TENANT_ID
const tenantPath = process.env.VUE_APP_TENANT_PATH
const systemName = process.env.VUE_APP_SYSTEM_NAME || 'CRM系统'

export const CONFIG = {
  TENANT_ID: tenantId,
  TENANT_PATH: tenantPath,
  SYSTEM_NAME: systemName,
  URL: url,
  FILE_URL: fileUrl,
  // oss上传文件名加随机字符串前缀,防止覆盖
  randomStr (len) {
    len = len || 32;
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let maxPos = chars.length;
    let pwd = '';
    for (let i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  isWechat () {
    let ua = window.navigator.userAgent.toLowerCase()
    return !(ua.indexOf('micromessenger') === -1)
  }
};
